import { Skeleton } from "@/components/ui/v2/skeleton";

function InsightsPageSkeleton() {
  return (
    <div className="flex flex-col gap-6">
      {/* Filter section */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Skeleton className="h-10 w-32" />
          <Skeleton className="h-10 w-10 rounded" />
          <Skeleton className="h-10 w-10 rounded" />
        </div>
        <Skeleton className="h-10 w-24" />
      </div>

      {/* KPI Cards Row */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-7 gap-4">
        {Array.from({ length: 7 }).map((_, index) => (
          <Skeleton key={index} className="h-20 rounded-lg" />
        ))}
      </div>

      {/* Table Section */}
      <div className="flex flex-col gap-4">
        <Skeleton className="h-6 w-32" />
        <div className="rounded-lg border border-border overflow-hidden">
          <Skeleton className="h-12 border-b border-border" />
          {Array.from({ length: 8 }).map((_, rowIndex) => (
            <Skeleton
              key={rowIndex}
              className="h-12 border-b border-border last:border-b-0"
            />
          ))}
        </div>
      </div>

      {/* Chart Section */}
      <div className="flex flex-col gap-4">
        <Skeleton className="h-6 w-48" />
        <Skeleton className="h-64 rounded-lg" />
      </div>
    </div>
  );
}

export default InsightsPageSkeleton;
